import React from "react";
import Router from "routes/Router";
import WithAuthentication from "Authentication/WithAuthentication.tsx";
import toast, { Toaster } from "react-hot-toast";
import Contact from "components/supplier/Contact";
import ReactDOM from "react-dom";
import { CartItemsProvider } from "context/ShoppingCartItems";

function App() {
  return (
    <div className="App">
      <CartItemsProvider>
        <Toaster />
        <WithAuthentication>
          <Router />
        </WithAuthentication>
      </CartItemsProvider>
    </div>
  );
}

export default App;
